import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconDossier: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconDossier"><Path d="M2 4H8V10H22V20H2V4Z" fill="currentColor"/><Path d="M10 4H15V8H10V4Z" fill="currentColor"/><Path d="M17 4H22V8H17V4Z" fill="currentColor"/></CentralIconBase>;
});

export default IconDossier;
